import { createApp } from "vue";
import App from "./App.vue";
import router from "./common/router";
import "animate.css";
import '@zkmelabs/widget/dist/style.css'
createApp(App).use(router).mount("#app");
